import { Mail, MailOpen, Trash2, ChevronDown, Star } from "lucide-react";

const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

// A single contact-message row (collapsed header + expandable body).
export const MessageRow = ({ m, isOpen, onToggleOpen, onToggleLead, onSetRead, onRemove }) => (
  <div
    data-testid={`message-row-${m.id}`}
    className={`rounded-lg border transition-colors ${m.read ? "border-white/5 bg-transparent" : "border-amber-500/30 bg-amber-500/[0.04]"}`}
  >
    <button
      type="button"
      onClick={() => onToggleOpen(m)}
      data-testid={`message-toggle-${m.id}`}
      className="w-full flex items-center justify-between gap-3 px-3 py-2.5 text-left"
    >
      <div className="min-w-0 flex items-center gap-2">
        {!m.read && <span className="h-2 w-2 rounded-full bg-amber-400 shrink-0" />}
        <div className="min-w-0">
          <p className={`truncate text-sm ${m.read ? "text-zinc-300" : "text-white font-medium"}`}>{m.subject}</p>
          <p className="truncate text-xs text-zinc-500">{m.name} · {m.email} · {fmtDateTime(m.created_at)}</p>
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <span
          role="button"
          tabIndex={0}
          onClick={(e) => onToggleLead(e, m)}
          data-testid={`message-lead-toggle-${m.id}`}
          className={`p-1.5 rounded-md hover:bg-amber-500/15 transition-colors ${m.lead ? "text-amber-400" : "text-zinc-500 hover:text-amber-400"}`}
          title={m.lead ? "Unmark as lead" : "Mark as lead"}
        >
          <Star className="h-3.5 w-3.5" fill={m.lead ? "currentColor" : "none"} />
        </span>
        <span
          role="button"
          tabIndex={0}
          onClick={(e) => { e.stopPropagation(); onSetRead(m, !m.read); }}
          data-testid={`message-read-toggle-${m.id}`}
          className="p-1.5 rounded-md hover:bg-white/10 text-zinc-400 hover:text-zinc-200 transition-colors"
          title={m.read ? "Mark unread" : "Mark read"}
        >
          {m.read ? <Mail className="h-3.5 w-3.5" /> : <MailOpen className="h-3.5 w-3.5" />}
        </span>
        <span
          role="button"
          tabIndex={0}
          onClick={(e) => onRemove(e, m)}
          data-testid={`message-delete-${m.id}`}
          className="p-1.5 rounded-md hover:bg-red-500/15 text-zinc-400 hover:text-red-400 transition-colors"
          title="Delete"
        >
          <Trash2 className="h-3.5 w-3.5" />
        </span>
        <ChevronDown className={`h-4 w-4 text-zinc-500 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </div>
    </button>
    {isOpen && (
      <div className="px-3 pb-3 pt-0 border-t border-white/5" data-testid={`message-body-${m.id}`}>
        <p className="mt-3 text-sm text-zinc-300 whitespace-pre-wrap break-words">{m.message}</p>
        <a
          href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`}
          data-testid={`message-reply-${m.id}`}
          className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-blue-400 hover:text-blue-300 transition-colors"
        >
          <Mail className="h-3.5 w-3.5" /> Reply via email
        </a>
      </div>
    )}
  </div>
);

export default MessageRow;
